import { Box, Grid } from "@mui/material";
import { Controller } from "react-hook-form";
import SelectYouTubeAccountWithConnect from "../SelectYouTubeAccountWithConnect";
import Select from "../../../../Form/Select";
import TextField from "../../../../Form/TextField";
import Switch from "../../../../Form/Switch";
import { youtubePrivacyStatusOptions } from "../../../../../utils/constants";
import {
  FIELD_REQUIRED,
  YOUTUBE_ACCOUNT_PLACEHOLDER,
  YOUTUBE_MADE_FOR_KIDS_LABEL,
  YOUTUBE_NOTIFY_SUBSCRIBERS_LABEL,
  YOUTUBE_PRIVACY_LEVEL_LABEL,
  YOUTUBE_TITLE_LABEL,
} from "../../../../../i18n/keysTranslations";

const YouTubePlatformFields = ({ control, errors, t }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <SelectYouTubeAccountWithConnect
        variant="filled"
        name="platformsData.youtube.account"
        label={t(YOUTUBE_ACCOUNT_PLACEHOLDER)}
        fullWidth
        control={control}
        errors={errors}
        rules={{
          required: {
            value: true,
            message: t(FIELD_REQUIRED),
          },
        }}
      />

      <Select
        variant="filled"
        name="platformsData.youtube.privacyStatus"
        label={t(YOUTUBE_PRIVACY_LEVEL_LABEL)}
        fullWidth
        control={control}
        errors={errors}
        options={youtubePrivacyStatusOptions.map((option) => ({
          value: option.value,
          label: t(option.label),
        }))}
        rules={{
          required: {
            value: true,
            message: t(FIELD_REQUIRED),
          },
        }}
      />

      <TextField
        label={t(YOUTUBE_TITLE_LABEL)}
        name="platformsData.youtube.title"
        variant="filled"
        fullWidth
        control={control}
        errors={errors}
        rules={{
          required: {
            value: true,
            message: t(FIELD_REQUIRED),
          },
        }}
      />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Controller
            name="platformsData.youtube.notifySubscribers"
            control={control}
            defaultValue={false}
            render={({ field }) => (
              <Switch
                isActive={field.value || false}
                onChangeIsActive={(value) => field.onChange(value)}
                labelActive={YOUTUBE_NOTIFY_SUBSCRIBERS_LABEL}
                labelDeactivate={YOUTUBE_NOTIFY_SUBSCRIBERS_LABEL}
                hasLabel
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="platformsData.youtube.madeForKids"
            control={control}
            defaultValue={false}
            render={({ field }) => (
              <Switch
                isActive={field.value || false}
                onChangeIsActive={(value) => field.onChange(value)}
                labelActive={YOUTUBE_MADE_FOR_KIDS_LABEL}
                labelDeactivate={YOUTUBE_MADE_FOR_KIDS_LABEL}
                hasLabel
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default YouTubePlatformFields;
